import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Lien de vérification vers l'annuaire officiel des AMO.
 *
 * « AMO agréé ANAH » est une phrase que n'importe qui peut écrire sur son
 * site, et plusieurs concurrents l'écrivent. Ce qui la rend vérifiable, c'est
 * l'annuaire que l'Anah met à disposition des particuliers : Transition
 * Énergie France y figure sous « TRANSITION ENERGIE France — 92200
 * NEUILLY-SUR-SEINE », avec la même adresse et le même numéro que ce site.
 * Vérifié le 1er octobre 2026 à la source.
 *
 * L'annuaire ne donne pas d'adresse propre à chaque entreprise : la recherche
 * passe par un formulaire et l'URL ne change pas. On ne peut donc pas pointer
 * la fiche directement, d'où le mode d'emploi en trois étapes — il vaut mieux
 * un chemin à suivre qu'un lien qui retomberait sur la page d'accueil.
 *
 * Si l'annuaire venait à proposer un lien permanent, le poser ici et retirer
 * le mode d'emploi.
 */

export const URL_ANNUAIRE =
  "https://france-renov.gouv.fr/annuaires-professionnels/accompagnant";

const AnnuaireFranceRenov = ({ className = "", detaille = false }) => (
  <div className={className}>
    <a
      href={URL_ANNUAIRE}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 min-h-[44px] text-sm font-medium text-green-800 underline hover:text-green-900"
    >
      <BadgeCheck aria-hidden="true" className="h-5 w-5 shrink-0" />
      Vérifier notre habilitation sur l'annuaire France Rénov'
      <span className="sr-only"> (site officiel, nouvelle fenêtre)</span>
    </a>

    {detaille && (
      <p className="mt-1 text-sm text-gray-700">
        Onglet « Rechercher un accompagnateur » → « Assistant à maîtrise
        d'ouvrage (AMO) » → saisissez <strong>Transition Energie France</strong>.
      </p>
    )}
  </div>
);

export default AnnuaireFranceRenov;
